import { createContext } from "@lit/context";
import { GameController } from "./controllers/gameController";

export const gameContext = createContext<GameController>(
  Symbol("game-context"),
);
